import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const TRUNCATE_LENGTH = 150;

export default function DescriptionCard({ description }) {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);
  const text = (description || '').trim();
  const needsExpand = text.length > TRUNCATE_LENGTH;
  const displayText = expanded || !needsExpand ? text : `${text.slice(0, TRUNCATE_LENGTH).trim()}…`;

  if (!text) return null;

  return (
    <section className="ri-section ri-description" aria-labelledby="ri-desc-heading">
      <h2 id="ri-desc-heading" className="ri-section-title">
        <span className="ri-section-icon" aria-hidden="true">📖</span>
        {t('restaurant.info.ourStory', 'Our Story')}
      </h2>
      <div className="ri-description-card">
        <div className="ri-description-text" style={{ maxWidth: '65ch' }}>
          {displayText}
        </div>
        {needsExpand && (
          <button
            type="button"
            className="ri-description-more"
            onClick={() => setExpanded(!expanded)}
            aria-expanded={expanded}
          >
            {expanded ? t('restaurant.info.readLess', 'Read less') : t('restaurant.info.readMore', 'Read more')}
          </button>
        )}
      </div>
    </section>
  );
}
